import { useEffect, useRef, useState } from 'react'
import { api } from '../services/api'
import './Autocomplete.css'

function Autocomplete({ type, value, onChange, placeholder }) {
  const [suggestions, setSuggestions] = useState([])
  const [open, setOpen] = useState(false)
  const boxRef = useRef(null)

  useEffect(() => {
    const query = value.trim()
    if (query.length < 2) {
      setSuggestions([])
      return
    }

    const timer = setTimeout(async () => {
      try {
        const data = await api.get(`/reference/${type}?q=${encodeURIComponent(query)}&limit=8`)
        setSuggestions(data.items)
      } catch {
        setSuggestions([])
      }
    }, 200)

    return () => clearTimeout(timer)
  }, [value, type])

  useEffect(() => {
    const handleClick = (event) => {
      if (boxRef.current && !boxRef.current.contains(event.target)) {
        setOpen(false)
      }
    }
    document.addEventListener('mousedown', handleClick)
    return () => document.removeEventListener('mousedown', handleClick)
  }, [])

  const pick = (item) => {
    onChange(item)
    setOpen(false)
  }

  return (
    <div className="ac" ref={boxRef}>
      <input
        className="onb-input"
        value={value}
        placeholder={placeholder}
        autoComplete="off"
        onChange={(event) => {
          onChange(event.target.value)
          setOpen(true)
        }}
        onFocus={() => setOpen(true)}
      />
      {open && suggestions.length > 0 && (
        <ul className="ac-list">
          {suggestions.map((item) => (
            <li key={item} className="ac-item" onMouseDown={() => pick(item)}>
              {item}
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}

export default Autocomplete
